import { STACKS } from '../constants';

export const getHost = () => {
  return process.env.NODE_ENV === 'development'
    ? STACKS.NORTH_EUROPE_AZURE.host
    : window.location.host;
};
